import cx from 'classix';
import { Icon, IconProps } from '../atoms';
import defaultAvatarImage from './avatar-default.png';

export type AvatarProps = (
  | {
      type: 'icon';
      icon: IconProps['type'];
    }
  | {
      type: 'initials';
      name: string;
    }
  | {
      type: 'avatar';
      avatarUrl?: string;
    }
) & {
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '5xl';
  additionalClassNames?: string;
  onClick?: () => void;
};

const getInitials = (fullName: string) => {
  const names = fullName.split(' ');
  let initials = names[0].substring(0, 1).toUpperCase();

  //Strip out middle initials if present
  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }

  return initials;
};

const sizeToIconPx = {
  xs: '16',
  sm: '20',
  md: '24',
  lg: '28',
  xl: '32',
  '2xl': '32',
  '5xl': '32',
};

export const Avatar = (props: AvatarProps) => {
  return (
    <button
      onClick={props.onClick}
      className={cx(
        props.size === 'xs' && 'w-6 h-6 text-xs',
        props.size === 'sm' && 'w-8 h-8 text-sm',
        props.size === 'md' && 'w-10 h-10 text-md',
        props.size === 'lg' && 'w-12 h-12 text-lg',
        props.size === 'xl' && 'w-14 h-14 text-xl',
        props.size === '2xl' && 'w-16 h-16 text-2xl',
        props.size === '5xl' && 'w-[113px] h-[113px] text-2xl',
        'rounded-full',
        (props.type === 'icon' || props.type === 'initials') && 'bg-avatar-bg',
        'flex',
        'justify-center',
        'items-center',
        'border-[0.75px] border-black/8',
        'font-semibold',
        'text-avatar-text',
        'bg-cover',
        props.onClick && 'focus:ring-4 ring-avatar-focus-ring ring-opacity-[14]',
        !props.onClick && 'cursor-default',
        props.additionalClassNames,
      )}
      //Tailwind doesn't handle non-local url background images well, so we use a style here
      style={{
        backgroundImage:
          props.type === 'avatar' ?
            props.avatarUrl ?
              `url(${props.avatarUrl})`
            : `url(${defaultAvatarImage})`
          : undefined,
      }}
    >
      {props.type === 'icon' && <Icon type={props.icon} size={sizeToIconPx[props.size]} />}
      {props.type === 'initials' && getInitials(props.name)}
    </button>
  );
};
